/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpsfacebookcomyourpageInputs */

const en_httpsfacebookcomyourpage = /** @type {(inputs: HttpsfacebookcomyourpageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://facebook.com/yourpage`)
};

const de_httpsfacebookcomyourpage = /** @type {(inputs: HttpsfacebookcomyourpageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://facebook.com/yourpage`)
};

/**
* | output |
* | --- |
* | "https://facebook.com/yourpage" |
*
* @param {HttpsfacebookcomyourpageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const httpsfacebookcomyourpage = /** @type {((inputs?: HttpsfacebookcomyourpageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpsfacebookcomyourpageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpsfacebookcomyourpage(inputs)
	return de_httpsfacebookcomyourpage(inputs)
});